import {Component, inject} from '@angular/core';
import {DataSubscriptionService} from "src/app/infrastructure/data-subscription.service";
import {GenericButtonComponent} from "src/app/presentation/common/generic-button/generic-button.component";
import {NgClass} from "@angular/common";
import {DataSynchronisationService} from "src/app/infrastructure/data-synchronisation.service";
import {
  AnimalButtonComponent
} from "src/app/presentation/main-view/information-center/animals/animal-button/animal-button.component";
import {SpinnerComponent} from "src/app/presentation/common/spinner/spinner.component";
import {AssetComponent} from "src/app/presentation/common/asset.component";
import {ViewportService} from "src/app/infrastructure/viewport.service";
import {allAnimalTypes, Animal, AnimalType, Paddock} from "src/app/infrastructure/moovement-api/models/asset";
import {DataType} from 'src/app/domain/domain-models';
import {
  InternalNotificationsStore,
  InternalNotificationType
} from 'src/app/infrastructure/internal-notifications/internal-notifications.store';
import {AnimalSelectionStore} from 'src/app/domain/assets/animals/animal-selection.store';
import {ScheduledUpdates} from 'src/app/infrastructure/scheduled-updates/scheduled-updates';
import {randomUuid} from 'src/app/domain/util/uuid/uuid';

@Component({
  selector: 'app-delete-animals-form',
  imports: [
    GenericButtonComponent,
    NgClass,
    AnimalButtonComponent,
    SpinnerComponent
  ],
  templateUrl: './delete-animals-form.component.html',
  styleUrl: './delete-animals-form.component.css'
})
export class DeleteAnimalsFormComponent extends AssetComponent {

  availablePaddocks: Array<Paddock> = []
  paddocks: Array<Paddock> = []
  years: Array<number> = []
  animalTypes: Array<AnimalType> = allAnimalTypes
  animals: Array<Animal> = []
  selectedYear?: number
  selectedPaddock?: string
  selectedAnimalType?: string

  private animalSelectionStore = inject(AnimalSelectionStore);
  private internalNotificationsStore = inject(InternalNotificationsStore);

  constructor(
    dataSynchronisationService: DataSynchronisationService,
    dataSubscriptionService: DataSubscriptionService,
    viewportService: ViewportService
  ) {
    super(dataSynchronisationService, dataSubscriptionService, viewportService);
  }

  ngOnInit() {
    const today = new Date();
    for (let i = 0; i < 10; i++) {
      this.years.push(today.getFullYear() - i)
    }
    this.animals = this.animalSelectionStore.entities();
    this.loading = false
  }

  deleteAnimals() {
    this.loading = true;
    this.animals.forEach(async animal => {
      await this.dataSynchronisationService.dissociateAsset(animal, DataType.animals);

      const name = animal.visualTag ? animal.visualTag : animal.id;
      const updates: ScheduledUpdates = {
        id: randomUuid(),
        updates: [
          {
            type: "setProfilePicture",
            data: {
              animalId: animal.id,
              profilePictureUrl: undefined,
            }
          }
        ],
        failureMessage: `Unable to clear profile picture for '${name}'.`
      }
      await this.dataSynchronisationService.scheduleUpdates(updates);
    });
    this.loading = false;
    this.router.navigate(['/main/information-center']);
    this.internalNotificationsStore.addNotification("Successfully deleted animal(s).", InternalNotificationType.SUCCESS, false);
  }
}
